<div style="width: 400px; height: 520px;">
    <sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true">
        <sc-dialog-title>
            {{'select loading zone' | translate:['tmc-yard.select-loading-zone.title',translationService.language]}}
        </sc-dialog-title>
        <sc-separator-line></sc-separator-line>
        <sc-flex-fitting-content [vertical]="true">
            <sc-scroll-pane>
                <sc-padding>
                    <ng-container *ngIf="station != null">
                        <ng-container
                            *ngFor="let loadingZone of station.stationUsage.availableLoadingZones; let i = index">
                            <sc-content-spacer [vertical]="true" *ngIf="i > 0"></sc-content-spacer>
                            <sc-bordered [highlight]="selected === loadingZone" (click)="setSelected(loadingZone)"
                                class="pointer">
                                <div [ngClass]="{'selected-item' : selected === loadingZone}">
                                    <sc-padding>
                                        {{loadingZone.name}}
                                    </sc-padding>
                                </div>
                            </sc-bordered>
                        </ng-container>
                    </ng-container>
                </sc-padding>
            </sc-scroll-pane>
        </sc-flex-fitting-content>
        <sc-separator-line></sc-separator-line>
        <sc-padding>
            <sc-flex>
                <sc-content-spacer [grow]="true"></sc-content-spacer>
                <button mat-stroked-button (click)="close()">
                    {{'cancel' | translate:['tmc-yard.action.cancel',translationService.language]}}
                </button>
                <sc-content-spacer></sc-content-spacer>
                <button mat-flat-button (click)="confirm()" [disabled]="selected == null">
                    {{'confirm' | translate:['tmc-yard.action.confirm',translationService.language]}}
                </button>
            </sc-flex>
        </sc-padding>
    </sc-flex>
</div>